module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<td>\r\n    <input type="text" id="registrales_titular" class="form-control" value="'+
((__t=(attributes.registrales_titular))==null?'':_.escape(__t))+
'" '+
((__t=(disabled))==null?'':_.escape(__t))+
' />\r\n</td>\r\n<td>\r\n    \r\n    <input type="text" id="registrales_registro" class="form-control" value="'+
((__t=(attributes.registrales_registro))==null?'':_.escape(__t))+
'" '+
((__t=(disabled))==null?'':_.escape(__t))+
' />\r\n \r\n    <!--\r\n            <select id="registrales_registro" class="form-control" '+
((__t=(disabled))==null?'':_.escape(__t))+
'>\r\n                    <option value="">[ -- ]</option>\r\n                    ';

                    for (var i = 1; i <= 50; i++) {
                            var selected = "";
                            if (attributes.registrales_registro === 'REGLABEL_' + i)
                                selected = "selected";
                            if (lang['REGLABEL_' + i]) 
                                    print('<option value="REGLABEL_' + i + '" ' + selected + '>' + lang['REGLABEL_' + i] + '</option>');
                    }
                    
__p+='\r\n            </select>        \r\n        -->\r\n</td>\r\n\r\n<td>\r\n    <input type="text" id="registrales_tomo" class="form-control number" maxlength="5"  value="'+
((__t=(attributes.registrales_tomo))==null?'':_.escape(__t))+
'" '+
((__t=(disabled))==null?'':_.escape(__t))+
'/>\r\n</td>\r\n<td>\r\n    <input type="text" id="registrales_libro" class="form-control number" maxlength="5"    value="'+
((__t=(attributes.registrales_libro))==null?'':_.escape(__t))+
'"  '+
((__t=(disabled))==null?'':_.escape(__t))+
' />\r\n</td>\r\n<td>\r\n    <input type="text" id="registrales_folio" class="form-control number" maxlength="5"   value="'+
((__t=(attributes.registrales_folio))==null?'':_.escape(__t))+
'" '+
((__t=(disabled))==null?'':_.escape(__t))+
'/>\r\n</td>\r\n<td>\r\n    <input type="text" id="registrales_finca" class="form-control " maxlength="5"    value="'+
((__t=(attributes.registrales_finca))==null?'':_.escape(__t))+
'" '+
((__t=(disabled))==null?'':_.escape(__t))+
' />\r\n</td>\r\n<td>\r\n    <input  style="    padding-left: 3px;"  type="text" id="registrales_idufir" class="form-control number" maxlength="14" value="'+
((__t=(attributes.registrales_idufir))==null?'':_.escape(__t))+
'"  '+
((__t=(disabled))==null?'':_.escape(__t))+
'/>\r\n</td>\r\n<td>\r\n    <input type="text" id="registrales_inscripcion" class="form-control number"   maxlength="3"   value="'+
((__t=(attributes.registrales_inscripcion))==null?'':_.escape(__t))+
'"  '+
((__t=(disabled))==null?'':_.escape(__t))+
' />\r\n</td>\r\n\r\n\r\n<td>\r\n    <div class="input-icon input-icon-right">\r\n        <i>m<sup>2</sup></i>\r\n        <input type="text" placeholder="0,00" id="registrales_superficie" class="form-control decimal text-right" value="'+
((__t=( attributes.registrales_superficie ))==null?'':_.escape(__t))+
'" '+
((__t=( disabled ))==null?'':_.escape(__t))+
'/>\r\n    </div>\r\n</td>\r\n<td>\r\n    <div class="input-group" id= "dtpickerRegistrales">\r\n        <input style="    padding-left: 5px;"  type=\'text\' id="registrales_fecha" class="form-control date" value="'+
((__t=(attributes.registrales_fecha))==null?'':_.escape(__t))+
'" '+
((__t=(disabled))==null?'':_.escape(__t))+
'/>\r\n        <span class="input-group-addon">\r\n            <span class="glyphicon glyphicon-calendar"></span>\r\n        </span>\r\n    </div>\r\n</td> \r\n<td >\r\n    <input type="text" id="registrales_cargas" class="form-control"   value="'+
((__t=(attributes.registrales_cargas))==null?'':_.escape(__t))+
'"  '+
((__t=(disabled))==null?'':_.escape(__t))+
' />\r\n</td>\r\n\r\n<td>\r\n    <div class="unbreakable"><span class="ion ion-ios-close text-red remove" aria-label="Remove"></span></div>\r\n</td>\r\n \r\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/views/goodsDetail/sections/registrales.ejs
// module id = 158
// module chunks = 0